import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { conformToMask } from 'text-mask-core';

import InputMask from '../index';

const weightMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  integerLimit: 9,
  allowNegative: false,
  allowLeadingZeroes: false,
};

export const weightMask = createNumberMask({ ...weightMaskOptions });

export function conformWeight(value) {
  const { conformedValue } = conformToMask(value, weightMask, {
    guide: false,
  });
  return conformedValue;
}

export default function InputMaskWeight(props) {
  return <InputMask {...props} mask={weightMask} type="text" />;
}
